import React, { useState } from 'react';
import { Input } from '@anonymizePro/components/ui/input';
import { Button } from '@anonymizePro/components/ui/button';
import InputSelector from '@anonymizePro/components/ui/input-selector';
import { useAtom } from 'jotai';
import { formAtom } from '@anonymizePro/components/form/formAtom';
import { isEmptyString } from '@app/utils/stringUtils';
import { PhoneInput } from '@anonymizePro/components/ui/phone-input';
import { Textarea } from '@anonymizePro/components/ui/textarea';
import Loader from '@app/components/ui/loader';
import { demonstrationContent } from '@anonymizePro/mock/contents';

interface FormProps {
    setStep: (value: number) => void;
}

function Index({ setStep }: FormProps) {
    const pages = ['Less than 1000', '2000', '3000', '5000', 'More than 5000'];
    const [formValue, setFormValue] = useAtom(formAtom);
    const [isLoading, setIsLoading] = useState(false);
    const handleOnChange = (value: string, type: string) => {
        setFormValue({
            ...formValue,
            [type]: value
        });
    };
    const isSubmitButtonDisable = isEmptyString(formValue.name) || isEmptyString(formValue.email) || isEmptyString(formValue.yearlyDocumentVolume);
    const handleOnSubmit = async (e: any) => {
        e.preventDefault();
        e.stopPropagation();
        setIsLoading(true);
        const response = await fetch('/api/email', {
            method: 'POST',
            body: JSON.stringify(formValue)
        });
        if (response.status === 200) {
            setIsLoading(false);
            setStep(1);
        } else {
            setIsLoading(false);
        }
    };
    return (
        <React.Fragment>
            <p className="anonymize-h2 text-center text-black-800">{demonstrationContent.title}</p>
            <p className="anonymize-p4 mb-12 mt-4 max-w-[428px] text-center text-black-700">{demonstrationContent.description}</p>
            <form onSubmit={handleOnSubmit} className="flex w-full flex-col gap-8">
                <Input isRequired={true} onChange={(e) => handleOnChange(e.target.value, 'name')} value={formValue.name} label="Name" placeholder="Enter your name" />
                <Input type="email" isRequired={true} onChange={(e) => handleOnChange(e.target.value, 'email')} value={formValue.email} label="Email Address" placeholder="Enter your email address" />
                <div className="flex w-full flex-col gap-2">
                    <span className="anonymize-p3 text-black-700">Phone Number (Optional)</span>
                    <PhoneInput placeholder="Enter a phone number" className="h-[45px]" value={formValue.phoneNumber} onChange={(number) => handleOnChange(number, 'phoneNumber')} />
                </div>
                <InputSelector
                    isRequired={true}
                    onValueChange={(value) => {
                        handleOnChange(value, 'yearlyDocumentVolume');
                    }}
                    label="Yearly Document Volume"
                    contents={pages}
                    value={formValue.yearlyDocumentVolume}
                />
                <Textarea onChange={(e) => handleOnChange(e.target.value, 'description')} value={formValue.description} label="Brief Description of Your Anonymization Needs" placeholder="Enter a Brief Description of Your Anonymization Needs" />
                <Button disabled={isSubmitButtonDisable} size="sm" className="w-[95px]">
                    {isLoading ? <Loader size="small" /> : 'Submit'}
                </Button>
            </form>
        </React.Fragment>
    );
}

export default Index;
